import React, { useContext, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import Printable from './components/Printable/Printable';
import Blog from './components/Blog/Blog';
import LandingPage from './components/LandingPage';
import MarkdownPage from './components/MarkdownPage';
import { ThemeContext } from './contexts/ThemeContext';
import 'antd/dist/reset.css';
import { changeAntdTheme } from 'mini-dynamic-antd-theme';
import { Languages } from './components/Data';
import { I18 } from './i18/i18';
import { useLocalStorage } from './hooks/useLocalStorage';

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const [theme] = useContext(ThemeContext);
  const [language, setLanguage] = useLocalStorage('language', 'EN');
  const [data, setData] = useState(Languages.EN);
  const [i18, setI18] = useState(I18.EN);

  const location = useLocation();
  const hideHeaderFooter = !['/print', '/markdown'].includes(location.pathname);
  const isLandingPage = location.pathname == "/"

  const onLanguageChange = (language) => {
    if (language === 'ES') {
      setLanguage(language);
    } else {
      setLanguage('EN');
    }
  };

  useEffect(() => {
    if (language === 'ES') {
      setData(Languages.ES);
      setI18(I18.ES);
    } else {
      setData(Languages.EN);
      setI18(I18.EN);
    }
  }, [language]);

  useEffect(() => {
    if (theme) {
      changeAntdTheme(theme.hex);
      changeTheme(theme);
    } else {
      localStorage.setItem(
        'portfolio-theme',
        JSON.stringify(data.defaultThemeColor),
      );
      changeAntdTheme('#cc0000');
      changeTheme(data.defaultThemeColor);
    }
  }, [theme]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  function changeTheme(theme) {
    document.documentElement.style.setProperty('--theme-color', theme.hex);
    document.documentElement.style.setProperty(
      '--theme-color-light',
      `rgba(${theme.rgb.r}, ${theme.rgb.g}, ${theme.rgb.b}, 0.5)`,
    );
    document.documentElement.style.setProperty(
      '--theme-color-lighter',
      `rgba(${theme.rgb.r}, ${theme.rgb.g}, ${theme.rgb.b}, 0.3)`,
    );
    document.documentElement.style.setProperty(
      '--theme-color-lightest',
      `rgba(${theme.rgb.r}, ${theme.rgb.g}, ${theme.rgb.b}, 0.1)`,
    );
  }

  return (
    <React.Fragment>
      {hideHeaderFooter && (
        <Header Data={data} i18={i18} OnLanguageChange={onLanguageChange} isLandingPage={isLandingPage} />
      )}

      <div className="page-content">
        <Routes>
          <Route path="/" element={<LandingPage Data={data} i18={i18} />} />
          <Route path="/blog" element={<Blog i18={i18} Language={language} />} />
          <Route path="/blog/:slug" element={<Blog i18={i18} Language={language} />} />
          <Route path="/print" element={<Printable Data={data} i18={i18} />} />
          <Route path="/markdown" element={<MarkdownPage />} />
        </Routes>
      </div>

      {hideHeaderFooter && <Footer Data={data} i18={i18} />}
    </React.Fragment>
  );
};

export default App;
